function requireServiceUrl(value, name) {
    if (!value || !value.trim()) {
        throw new Error(`${name} ortam değişkeni tanımlanmalıdır.`)
    }

    let url
    try {
        url = new URL(value.trim())
    } catch {
        throw new Error(`${name} geçerli bir servis adresi olmalıdır.`)
    }

    if (!['http:', 'https:'].includes(url.protocol) || url.search || url.hash) {
        throw new Error(`${name} sorgu veya fragment içermeyen bir HTTP(S) adresi olmalıdır.`)
    }

    return url.href.replace(/\/+$/, '')
}

export const API_BASE_URL = `${requireServiceUrl(process.env.VUE_APP_API_BASE_URL, 'VUE_APP_API_BASE_URL')}/`
export const API_ROOT_URL = new URL('/', API_BASE_URL).href
export const KIGAGU_API_BASE_URL = requireServiceUrl(process.env.VUE_APP_KIGAGU_API_BASE_URL, 'VUE_APP_KIGAGU_API_BASE_URL')
